import { atom } from "nanostores";

export const drawerTypeTagsStore = atom<"Thème" | "Époque" | "Pays" | null>(null);
